export enum AmpOnboardingPageStep {
  ONBOARD = 'onboard',
  EXISTING_PLAN = 'existing-plan',
  SIGN_UP = 'sign-up',
  SIGN_IN = 'sign-in',
  CONTACT_SUPPORT = 'contact_support',
  ZENDESK_REQUEST_SENT = 'zendesk-request-sent',
}
